import React from "react";
import PropTypes from "prop-types";
import { InlineTabs } from "components/common/inline-tabs";

export const SettingsInlineTabs = ({ currentPage, slug }) => (
  <InlineTabs tabValues={ tabValues(currentPage, slug) } />
);

SettingsInlineTabs.propTypes = {
  currentPage: PropTypes.oneOf(["account", "user", "integration"]).isRequired,
  slug: PropTypes.string.isRequired
};

const tabValues = (currentPage, slug) => (
  [
    {
      name: "Account Settings",
      path: `/accounts/${slug}/settings/account/usage`,
      isSelected: currentPage === "account"
    },
    {
      name: "User Settings",
      path: `/accounts/${slug}/settings/user/info`,
      isSelected: currentPage === "user"
    },
    {
      name: "Integration Settings",
      path: `/accounts/${slug}/settings/integration`,
      isSelected: currentPage === "integration"
    }
  ]
);



// WEBPACK FOOTER //
// ./src/js/components/settings/settings-inline-tabs.jsx